import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'helpers/translateHelper';
import { formatDateTime } from 'helpers/dateTimeFormatter';
import './style.scss';

const TrendCommentsTooltip = ({ comment }) => {
    return (
        <div className='trend-comments-tooltip'>
            <div className='subject-text'>{comment?.subjectText}</div>
            <span className='comment-timestamp'>{formatDateTime(comment?.timestamp)}</span>
            <span className='comment-text'>{comment?.commentText}</span>
            {comment?.internal &&
                <div className='user-email'>
                    <span>
                        {comment?.author ?? ''}
                    </span>
                    <span className='internal-label'>
                        {translate('ABB.Powertrain.Frontend.opTrendCommentsInternalLabel')}
                    </span>
                </div>
            }
        </div>
    );
};

TrendCommentsTooltip.propTypes = {
    comment: PropTypes.shape({
        subjectText: PropTypes.string,
        timestamp: PropTypes.string,
        commentText: PropTypes.string,
        internal: PropTypes.bool,
        author: PropTypes.string
    }).isRequired
};

export default TrendCommentsTooltip;
